<template>
  <div class="empty-message">
    <span v-if="message" v-html="message"></span>
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'SmsEmptyMessage',

  props: {
    message: {
      type: String,
      default: ''
    }
  }
};
</script>

<style src="./scoped.scss" lang="scss" scoped />
